import React from "react";

interface PrivacyIconProps {
  color?: string;
}

export const PrivacyIcon: React.FC<PrivacyIconProps> = ({
  color = "#bfa073",
}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect
      x="5"
      y="11"
      width="14"
      height="10"
      rx="2"
      stroke={color}
      strokeWidth="1.8"
    />
    <path
      d="M8 11V8C8 5.79 9.79 4 12 4C14.21 4 16 5.79 16 8V11"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
